import {
    mapFdrToHtmlColor
} from '../query-colour-mapper'

/**
 * Hourly data should have the following structure:
 * {
 *      DF: "string",
 *      DateTime: "string",
 *      Direction: "string",
 *      FBI: "string",
 *      FDR: "string",
 *      Humidity: "string",
 *      Speed: "string",
 *      Temperature: "string"
 * }
 * @param {*} hourlyData 
 * @param {*} detailsContainer 
 */
export function drawFdrColumnChart(hourlyData, detailsContainer, chartHeight) {
    // Create the temperature data array
    const temp = [['Datetime', 'FDR', { role: "style" }]];

    hourlyData.forEach((item) => {
        temp.push([
            new Date(item['DateTime']), +item['FDR'], mapFdrToHtmlColor(+item['FDR'])
        ]);
    })

    const data = google.visualization.arrayToDataTable(temp);

    var options = {
        title: "Fire Danger Rating",
        chartArea: {width: '85%'},
        bar: {groupWidth: "90%"},
        legend: { position: "none" },
        vAxis: {
            maxValue: 4,
            ticks: [0, 1, 2, 3, 4]
        },
        height: +chartHeight.slice(0, -2)
      };

    const chartContainer = $(`<div class="no-data ` + 
            `column-chart-container ` + 
            `chart-container-style" ` + 
            `id="fdr-column-chart-id"` + 
            `style="height:${chartHeight};"></div>`);
    detailsContainer.append(chartContainer);

    const chart = new google.visualization.ColumnChart(document.getElementById('fdr-column-chart-id'));
    chart.draw(data, options);
}